module.exports = __webpack_public_path__ + "static/fonts/Robotolight.38e1ed9.woff2";